import { Popover } from "antd";
import React from "react";

const PopOverMenu = ({ content, button, placement }) => {
  return (
    <Popover
      placement={placement || "bottom"}
      className={`cursor_pointer`}
      content={content}
      trigger="click"
    >
      {button}
    </Popover>
  );
};

export default PopOverMenu;
